import { Link } from 'react-router-dom'
import { Container } from '../ui/Container'
import { CTA } from '../ui/CTA'
import { Eyebrow } from '../ui/Eyebrow'
import { Reveal } from '../ui/Reveal'
import { usePublishedCaseStudies } from '../../hooks/useCaseStudies'

export function CasesPreview() {
  const { cases, loading } = usePublishedCaseStudies(3)

  return (
    <section className="border-b border-ink/10 py-24 md:py-32">
      <Container>
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <Reveal>
            <Eyebrow>Cases</Eyebrow>
            <h2 className="mt-6 max-w-xl font-display text-4xl font-semibold leading-tight tracking-tight text-balance md:text-5xl">
              Real problems. Real systems.
            </h2>
          </Reveal>
          <Reveal delay={100}>
            <CTA to="/cases" variant="ghost">
              View all cases
            </CTA>
          </Reveal>
        </div>

        {loading ? (
          <div className="mt-16 grid gap-6 md:grid-cols-3">
            {[0, 1, 2].map((i) => (
              <div key={i} className="h-72 animate-pulse rounded-3xl bg-bone" />
            ))}
          </div>
        ) : cases.length === 0 ? (
          <p className="mt-16 text-sm text-graphite">[CASE STUDY PLACEHOLDER — none published yet]</p>
        ) : (
          <div className="mt-16 grid gap-6 md:grid-cols-3">
            {cases.map((item, i) => (
              <Reveal key={item.id} delay={i * 100}>
                <Link
                  to={`/cases/${item.slug}`}
                  className="group flex h-full flex-col justify-between rounded-3xl border border-ink/10 bg-paper p-8 transition-all duration-300 hover:border-ink hover:shadow-xl hover:shadow-ink/5"
                >
                  <div>
                    <span className="text-xs font-medium uppercase tracking-[0.15em] text-signal">
                      {item.industry ?? 'Case study'}
                    </span>
                    <h3 className="mt-4 font-display text-xl font-semibold leading-snug tracking-tight">
                      {item.title}
                    </h3>
                  </div>
                  <div className="mt-10 flex items-center justify-between text-sm">
                    <span className="text-ink/60">{item.service_type ?? 'Project'}</span>
                    <span className="text-lg text-ink/30 transition-all duration-300 group-hover:translate-x-1 group-hover:text-signal">
                      →
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </Container>
    </section>
  )
}
